import { IValidationMessage } from '../../../models/validation-message.interface';

const yearValidationMessageList: IValidationMessage[] = [
    {
        error: 'required',
        message: 'Пожалуйста, заполните год окончания срока действия карты'
    },
    {
        error: 'mask',
        message: 'Пожалуйста, заполните год окончания срока действия карты корректно'
    }
];

export default yearValidationMessageList;
